"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function unformat(value) {
    if (!value) {
        return '';
    }
    return value.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
}
exports.default = unformat;
//# sourceMappingURL=unformat.js.map